module.exports = __webpack_public_path__ + "static/media/Almarai-Bold.62027b7a.ttf";